import React, { useEffect } from 'react';
import '../styles/components/retired-practice-message.scss';

const CARET_ICON = '/assets/images/caret-left.svg';
const LEARN_MORE_URL =
  'https://help.patientfusion.com/s/article/faqs-for-transitioning-from-patient-fusion-to-followmyhealth';

const RetiredPracticeMessage = ({
  onGoBackToAccountSelector,
  onSetSpinner,
  practiceName,
  shouldDisplayBackButton,
}) => {
  useEffect(() => {
    onSetSpinner(false);
  }, [onSetSpinner]);

  const practice = practiceName || 'your practice';

  return (
    <div className="retired-practice__container">
      {shouldDisplayBackButton && (
        <div className="retired-practice__header">
          <button
            className="retired-practice__back-button btn--link"
            onClick={() => onGoBackToAccountSelector()}
          >
            <span>
              <img
                src={CARET_ICON}
                alt="Caret Icon Directed Left"
                className="retired-practice__back-button-icon"
              />
            </span>
            Back to Accounts
          </button>
        </div>
      )}
      <div className="retired-practice__content">
        <div className="retired-practice__box">
          <h2 className="retired-practice__header-text">
            Patient Fusion is now closed for {practice}
          </h2>
          <div className="retired-practice__box-content-left">
            <p className="retired-practice__section-heading">
              <strong>To access your health records</strong>
            </p>
            <p>
              Call {practice}’s office and ask for a copy of your records. They
              can also tell you how they will share information with you from
              now on.
            </p>
            <p className="retired-practice__section-heading">
              <strong>To book or request an appointment</strong>
            </p>
            <p>
              Call {practice}’s office. You may also be able to book on their
              website.
            </p>
          </div>
          <hr className="retired-practice__hr" />
          <a
            className="retired-practice__learn-more"
            href={LEARN_MORE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Read more about this change
          </a>
        </div>
      </div>
    </div>
  );
};

export default RetiredPracticeMessage;
